import type { MessageKey } from "./ru"

export const faMessages = {
  "common.loading": "در حال بارگذاری...",
  "common.error": "خطا",
  "common.back": "بازگشت",
  "common.next": "بعدی",
  "common.search": "جستجو",
  "auth.loginErrorTitle": "خطای ورود",
  "auth.openViaTelegram": "برنامه را از طریق Telegram باز کنید",
  "auth.telegramRequired": "برنامه باید از طریق Telegram باز شود",
  "auth.authorizationError": "خطای احراز هویت",
  "device.rotatePortrait": "دستگاه را به حالت عمودی بچرخانید",
  "country.brazil": "برزیل",
  "country.vietnam": "ویتنام",
  "country.egypt": "مصر",
  "country.india": "هند",
  "country.indonesia": "اندونزی",
  "country.iran": "ایران",
  "country.spain": "اسپانیا",
  "country.italy": "ایتالیا",
  "country.kazakhstan": "قزاقستان",
  "country.colombia": "کلمبیا",
  "country.malaysia": "مالزی",
  "country.mexico": "مکزیک",
  "country.nigeria": "نیجریه",
  "country.pakistan": "پاکستان",
  "country.russia": "روسیه",
  "country.usa": "ایالات متحده",
  "country.turkey": "ترکیه",
  "country.uzbekistan": "ازبکستان",
  "country.ukraine": "اوکراین",
  "country.philippines": "فیلیپین",
  "countrySelection.chooseCountry": "کشور را انتخاب کنید",
  "countrySelection.openAria": "انتخاب کشور",
  "languageSelection.chooseLanguage": "زبان را انتخاب کنید",
  "commercial.direction.autotrade": "بازار خودرو",
  "commercial.direction.insurance": "بیمه",
  "commercial.direction.pitstop": "مرکز خدمات",
  "commercial.direction.techhelp": "امداد جاده‌ای",
  "commercial.searchLabel": "جستجوی BeepApp",
  "commercial.cityPlaceholder": "شهر را وارد کنید",
  "commercial.emptyTitle": "امروز پیشنهادی نیست",
  "commercial.emptyLine1": "هنوز شریک فعال BeepApp در شهر شما وجود ندارد",
  "commercial.emptyLine2": "در حال یافتن و متصل کردن آن‌ها هستیم",
  "commercial.emptyLine3": "پیشنهادهای جدید به‌صورت خودکار اینجا ظاهر می‌شوند",
  "commercial.helperLine1": "شهر خود را وارد کنید تا",
  "commercial.helperLine2": "پیشنهادهای موجود را ببینید",
  "commercial.partnerPrompt": "می‌خواهید شریک BeepApp شوید؟",
  "commercial.apply": "ارسال درخواست",
  "main.admin": "مدیریت",
  "main.garage": "گاراژ",
  "main.signalSent": "پیام ارسال شد",
  "main.partnerInviteUnavailable": "دعوت شریک در دسترس نیست",
  "main.enterPlate": "پلاک را وارد کنید",
  "main.searchError": "خطای جستجو",
  "main.signalSendError": "ارسال پیام ناموفق بود",
  "main.shareCardPrefix": "کارت پلاک",
  "main.shareLinkError": "آماده‌سازی لینک ممکن نشد",
  "main.searchByPlateAria": "جستجو بر اساس پلاک",
  "main.russianPlateAria": "پلاک روسی",
  "main.plateAria": "پلاک",
  "main.findPlateAria": "یافتن پلاک",
  "main.loadingVehicle": "در حال بارگذاری کارت پلاک…",
  "main.leaveSignal": "ارسال پیام",
  "main.share": "اشتراک‌گذاری",
  "signalSelection.chooseType": "نوع پیام را انتخاب کنید",
  "signalSelection.category.attention": "شخصی",
  "signalSelection.category.road": "جاده‌ای",
  "signalSelection.category.urgent": "فوری",
  "signalSelection.chooseSignal": "پیام را انتخاب کنید",
  "signalSelection.suggestOwn": "پیشنهاد خودتان",
  "signalConfirmation.title": "تأیید پیام",
  "signalConfirmation.plateHeading": "پلاک را بررسی کنید",
  "signalConfirmation.signalHeading": "پیام انتخاب‌شده را بررسی کنید",
  "signalConfirmation.replyTitle": "اجازه پاسخ در Telegram",
  "signalConfirmation.replyBody": "این گزینه را فعال کنید تا مالک پلاک بتواند\nدر Telegram به شما پیام دهد. پاسخ فقط زمانی ممکن است که\n@username داشته باشید. تصمیم برای پاسخ\nبا مالک پلاک است.",
  "signalConfirmation.consentText": "تأیید می‌کنم این پیام مربوط به\nیک وضعیت واقعی است و هرزنامه\nیا گزارش دروغین نیست.",
  "signalConfirmation.warning": "پس از ارسال، امکان\nتغییر پیام وجود ندارد",
  "signalConfirmation.sending": "در حال ارسال…",
  "signalConfirmation.send": "ارسال",
  "partner.loadingAria": "در حال بارگذاری",
  "partner.title": "برنامه همکاری",
  "partner.offerLine1": "بدون محدودیت زمانی ۳۰٪ از همه پرداخت‌ها دریافت کنید",
  "partner.offerLine2": "از کاربرانی که به BeepApp دعوت می‌کنید",
  "partner.offerLine3": "از طریق برنامه همکاری Telegram",
  "partner.connectUnavailable": "اتصال پس از راه‌اندازی برنامه Telegram Affiliate در دسترس خواهد بود.",
  "partner.connectTelegram": "اتصال در Telegram",
  "partner.qrAria": "کد QR لینک همکاری",
  "partner.download": "دانلود",
  "partner.promoHeading": "کد تخفیف شخصی بسازید",
  "partner.promoHelperLine1": "کد تخفیف یک سال اشتراک اضافی فعال می‌کند",
  "partner.promoHelperLine2": "و به جذب کاربران کمک می‌کند",
  "partner.promoAria": "کد تخفیف",
  "partner.affiliateHeading": "لینک همکاری شما",
  "partner.affiliateHelper": "لینک را ذخیره کنید تا کد QR شخصی بسازید",
  "partner.affiliateAria": "لینک همکاری",
  "partner.qrNoteLine1": "کد QR را می‌توان روی خودرو،",
  "partner.qrNoteLine2": "شبکه‌های اجتماعی و مواد تبلیغاتی قرار داد",
  "partner.save": "ذخیره",
  "partner.reset": "بازنشانی",
  "partner.resetConfirm": "لینک همکاری ذخیره‌شده بازنشانی شود؟ کد تخفیف برای شما باقی می‌ماند.",
  "partner.promoFormatError": "کد تخفیف باید بین ۴ تا ۱۵ نویسه باشد.",
  "partner.affiliateHostError": "فقط لینک‌های t.me یا telegram.me مجاز هستند.",
  "partner.affiliatePathError": "مسیر Telegram در لینک وجود ندارد.",
  "partner.affiliateFormatError": "لینک همکاری نامعتبر است.",
  "partner.loadError": "خطای بارگذاری",
  "partner.checkInputError": "اطلاعات واردشده را بررسی کنید",
  "garageActivation.promoInvalid": "کد تخفیف نامعتبر است",
  "garageActivation.plateOccupied": "این پلاک قبلاً متصل شده است",
  "garageActivation.activateError": "فعال‌سازی گاراژ ممکن نشد",
  "garageEntry.loadJournalError": "بارگذاری دفتر ثبت ممکن نشد",
  "garageEntry.loadStatusesError": "بارگذاری وضعیت‌ها ممکن نشد",
  "garageEntry.activationSuccess": "گاراژ با موفقیت فعال شد",
  "garageEntry.plateAttached": "پلاک متصل شد",
  "garageEntry.attachError": "اتصال پلاک ممکن نشد",
  "garageEntry.activationNote": "گاراژ خود را فعال کنید",
  "garageSheet.activationTitle": "فعال‌سازی گاراژ",
  "garageSheet.plateHelper": "پلاک خودرو را وارد کنید",
  "garageSheet.promoHelper": "کد تخفیف دارید؟",
  "garageSheet.cleanBonusLine1": "پس از فعال‌سازی، ۱ ساعت فرصت دارید",
  "garageSheet.cleanBonusLine2": "تا «شروع پاک» را رایگان استفاده کنید",
  "garageSheet.activationFor": "فعال‌سازی برای",
  "garageSheet.cost": "هزینه",
  "garageSheet.ownerConsentLine1": "تأیید می‌کنم مالک",
  "garageSheet.ownerConsentLine2": "خودروی دارای",
  "garageSheet.ownerConsentLine3": "پلاک مشخص‌شده هستم.",
  "garageSheet.processing": "در حال انجام...",
  "garageSheet.attach": "اتصال",
  "garageSheet.pay": "پرداخت",
  "garageLifecycle.cleanTitle": "شروع پاک",
  "garageLifecycle.deactivateTitle": "غیرفعال‌سازی گاراژ",
  "garageLifecycle.cleanWarningLine1": "سابقه پلاک حذف خواهد شد",
  "garageLifecycle.cleanWarningLine2": "و قابل بازیابی نخواهد بود!",
  "garageLifecycle.deactivateWarningLine1": "پس از غیرفعال‌سازی، دسترسی به",
  "garageLifecycle.deactivateWarningLine2": "ویژگی‌های گاراژ فعال پایان می‌یابد",
  "garageLifecycle.willBeDeleted": "حذف خواهد شد",
  "garageLifecycle.cleanRemovedLine1": "• همه ورودی‌های دفتر ثبت",
  "garageLifecycle.cleanRemovedLine2": "• سابقه پیام‌های دریافتی",
  "garageLifecycle.cleanRemovedLine3": "• شمارنده‌های عمومی پیام‌ها",
  "garageLifecycle.cleanRemovedLine4": "  در کارت پلاک",
  "garageLifecycle.willRemain": "باقی می‌ماند",
  "garageLifecycle.cleanPreservedLine1": "• اتصال پلاک به گاراژ",
  "garageLifecycle.cleanPreservedLine2": "• مدت باقی‌مانده فعال‌سازی",
  "garageLifecycle.cleanPreservedLine3": "• وضعیت انتخاب‌شده پلاک",
  "garageLifecycle.cleanPreservedLine4": "• تعداد کل بازدیدهای کارت پلاک",
  "garageLifecycle.freeFirstHour": "در ساعت اول رایگان",
  "garageLifecycle.willBecomeUnavailable": "غیرفعال خواهد شد",
  "garageLifecycle.deactivateRemovedLine1": "• دفتر ثبت",
  "garageLifecycle.deactivateRemovedLine2": "• انتخاب و استفاده از وضعیت پلاک",
  "garageLifecycle.deactivateRemovedLine3": "• به‌طور خودکار از «AutoClan» خارج می‌شوید",
  "garageLifecycle.deactivateRemovedLine4": "• بازار خودرو",
  "garageLifecycle.deactivateRemovedLine5": "• بیمه",
  "garageLifecycle.deactivateRemovedLine6": "• مرکز خدمات",
  "garageLifecycle.deactivateRemovedLine7": "• امداد جاده‌ای",
  "garageLifecycle.deactivateRemovedLine8": "• پلاک از گاراژ جدا خواهد شد",
  "garageLifecycle.willRemainAvailable": "در دسترس می‌ماند",
  "garageLifecycle.deactivatePreservedLine1": "• همراه",
  "garageLifecycle.deactivatePreservedLine2": "• دیسپچر",
  "garageLifecycle.deactivatePreservedLine3": "• جستجو بر اساس پلاک و مشاهده",
  "garageLifecycle.deactivatePreservedLine4": "  کارت عمومی خودرو",
  "garageLifecycle.deactivatePreservedLine5": "• امکان فعال‌سازی دوباره",
  "garageLifecycle.deactivatePreservedLine6": "  گاراژ در هر زمان",
  "garageLifecycle.cleanConsentLine1": "موافقت خود را با حذف",
  "garageLifecycle.cleanConsentLine2": "تمام سابقه این پلاک",
  "garageLifecycle.cleanConsentLine3": "بدون امکان بازیابی تأیید می‌کنم.",
  "garageLifecycle.deactivateConsentLine1": "غیرفعال‌سازی و",
  "garageLifecycle.deactivateConsentLine2": "پایان دسترسی به همه",
  "garageLifecycle.deactivateConsentLine3": "ویژگی‌های گاراژ فعال را تأیید می‌کنم.",
  "garageLifecycle.clean": "پاک کردن",
  "garageLifecycle.deactivate": "غیرفعال کردن",
} satisfies Record<MessageKey, string>
